export default {
  hall1: {
    label: 'Main hall',
    color: '#fcad43',
  },
  other: {
    color: 'gray',
    label: 'Main hall',
    cardBackgroundColor: 'rgb(255, 81, 0)',
    isCross: true,
  },
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/tracks.js